import { Icons, Logos } from '@assets';
import * as S from '@components/navbar/style/MobileNavbar.styled';
import { IUser } from '@types';
import React from 'react';

interface NavbarHeaderProps {
    user: IUser | null;
    isOpen: boolean;
    onToggleMenu: () => void;
    onCloseMenu: () => void;
}

export const NavbarHeader: React.FC<NavbarHeaderProps> = ({
    user,
    isOpen,
    onToggleMenu,
    onCloseMenu,
}) => {
    return (
        <S.MobileHeader>
            <S.MobileLogo>
                <img src={Logos.LogoWhite} alt="Proga.pro logo" />
            </S.MobileLogo>

            <S.MobileRight>
                <S.MobileBalance>
                    <img src={Icons.Wallet} alt="wallet" />
                    {`${user?.state ?? 0} ₽`}
                </S.MobileBalance>

                {!isOpen ? (
                    <S.BurgerButton onClick={onToggleMenu} $open={isOpen}>
                        <span />
                        <span />
                        <span />
                    </S.BurgerButton>
                ) : (
                    <S.CloseButton onClick={onCloseMenu} />
                )}
            </S.MobileRight>
        </S.MobileHeader>
    );
};
